import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar, { SIDEBAR_COLLAPSED_WIDTH } from './Sidebar';
import AuthGuard from '../auth/AuthGuard';
import RoutePermissionGuard from '../auth/RoutePermissionGuard';
import { PermissionProvider } from '../../contexts/PermissionContext';

const HEADER_HEIGHT = 60;

export default function AppShell({ children }) {
  const [collapsed, setCollapsed] = useState(true);
  const layoutOffset = SIDEBAR_COLLAPSED_WIDTH;

  return (
    <PermissionProvider>
      <div className="app-layout-shell">
        <Sidebar collapsed={collapsed} onToggle={() => setCollapsed((value) => !value)} />
        <Header leftOffset={layoutOffset} />

        <main
          className="app-layout-main"
          style={{
            marginLeft: layoutOffset,
            paddingTop: HEADER_HEIGHT,
          }}
        >
          <div className="app-layout-content">
            {/* Single, central auth + live-permission gate. PermissionProvider
                keeps /me/permissions authoritative and mirrors it to the legacy
                localStorage snapshot used by older screens. */}
            <AuthGuard>
              <RoutePermissionGuard>
                {children ?? <Outlet />}
              </RoutePermissionGuard>
            </AuthGuard>
          </div>
        </main>
      </div>
    </PermissionProvider>
  );
}
